var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPuzzle2Line = function SvgPuzzle2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.75 6.75a3 3 0 1 1 6 0h3.75a.75.75 0 0 1 .75.75v3.128a.75.75 0 0 1-1 .707 1.5 1.5 0 1 0 0 2.83.75.75 0 0 1 1 .707V18a.75.75 0 0 1-.75.75h-12a.75.75 0 0 1-.75-.75V7.5a.75.75 0 0 1 .75-.75zm3-1.5a1.5 1.5 0 0 0-1.415 2 .75.75 0 0 1-.707 1H7.25v9h10.5v-1.5a3 3 0 0 1 0-6v-1.5h-3.878a.75.75 0 0 1-.707-1 1.5 1.5 0 0 0-1.415-2"
  })));
};
export default SvgPuzzle2Line;